<section>
  <div class="section-header">
    <label *ngIf="!tabs">{{ title }}</label>
    <div class="tabs">
      <span
        *ngFor="let tab of tabs"        
        (click)="tabClickHandler(tab.name)"
        [ngClass]="tab.active == true ? 'active' : '' "
        >{{ tab.label }}</span
      >
    </div>
    <div class="expand" *ngIf="expand">
      <img src="/assets/images/open.svg" alt="Expand" />
    </div>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</section>
